export * from './patient.interface';
export * from './patients-response.interface';
export * from './patient-files.interface';
